import React from 'react'
import { Route, Routes } from 'react-router'

import AdminDashboardPage from '../app/admin/dashboard/pages/AdminDashboardPage'

import QueueDashboardPage from '../app/admin/queues/pages/QueueDashboardPage'
import QueueConfigPage from '../app/admin/queues/pages/QueueConfigPage'
import BusinessHoursPage from '../app/admin/queues/pages/BusinessHoursPage'
import BusinessBreaksPage from '../app/admin/queues/pages/BusinessBreaksPage'
import BusinessHolidayPage from '../app/admin/queues/pages/BusinessHolidayPage'
import BusinessServicesPage from '../app/admin/queues/pages/BusinessServicesPage'
import BusinessStaffPage from '../app/admin/queues/pages/BusinessStaffPage'
import UserListPage from '../app/admin/user/pages/UserListPage'
import UserDetailsPage from '../app/admin/user/pages/UserDetailsPage'
import UserRoleListPage from '../app/admin/user/pages/UserRoleListPage'



import ManageAdsPage from '../app/admin/cms/pages/ManageAdsPage'
import ManageNewsPage from '../app/admin/cms/pages/ManageNewsPage'
import ManageKioskInfoPage from '../app/admin/cms/pages/ManageKioskInfoPage'
import KioskInfoDetailsPage from '../app/admin/cms/pages/KioskInfoDetailsPage'
import ManageKioskInfoCategoryPage from '../app/admin/cms/pages/ManageKioskInfoCategoryPage'
import KioskInfoCategoryDetailsPage from '../app/admin/cms/pages/KioskInfoCategoryDetailsPage'
import ManageKioskFaqPage from '../app/admin/cms/pages/ManageKioskFaqPage'
import ManageKioskDirectoryPage from '../app/admin/cms/pages/ManageKioskDirectoryPage'
import ReceptionRoutes from './ReceptionRoutes'
import DoctorRoutes from './DoctorRoutes'
import DisplayRoutes from './DisplayRoutes'
import PatientRoutes from './PatientRoutes'
import AccountsRoutes from './AccountsRoutes'
import AccountsDashboardPage from '../app/accounts/dashboard/pages/AccountsDashboardPage'




function ManagerRoutes() {
  return (
    <>
    <Routes>
        {/* Admin */}
        {/* <Route path="/" element={<AdminDashboardPage/>}></Route> */}
        <Route path="/" element={<AccountsDashboardPage/>}></Route>


        {/* Users */}
        <Route path="/user/list" element={<UserListPage /> }></Route>
        <Route path="/user/details/:id" element={<UserDetailsPage /> }></Route>
        <Route path="/user/role" element={<UserRoleListPage /> }></Route>
       
        <Route path="/queue/dashboard" element={<QueueDashboardPage /> }></Route>
        <Route path="/queue/config/:id" element={<QueueConfigPage /> }></Route>
        <Route path="/queue/business-hours/:id" element={<BusinessHoursPage /> }></Route>
        <Route path="/queue/business-breaks/:id" element={<BusinessBreaksPage /> }></Route>
        <Route path="/queue/business-holiday/:id" element={<BusinessHolidayPage /> }></Route>
        <Route path="/queue/services/:id" element={<BusinessServicesPage /> }></Route>
        <Route path="/queue/staff/:id" element={<BusinessStaffPage /> }></Route>

        {/* CMS */}
        <Route path="/cms/ads" element={<ManageAdsPage /> }></Route>
        <Route path="/cms/news" element={<ManageNewsPage /> }></Route>
        <Route path="/cms/kiosk-info" element={<ManageKioskInfoPage /> }></Route>
        <Route path="/cms/kiosk-info/details/:id" element={<KioskInfoDetailsPage /> }></Route>
        <Route path="/cms/kiosk-category" element={<ManageKioskInfoCategoryPage /> }></Route>
        <Route path="/cms/kiosk-category/details/:id" element={<KioskInfoCategoryDetailsPage /> }></Route>
        <Route path="/cms/kiosk-faq" element={<ManageKioskFaqPage /> }></Route>
        <Route path="/cms/kiosk-directory" element={<ManageKioskDirectoryPage /> }></Route>
    </Routes>
    <ReceptionRoutes/>
    <DoctorRoutes/>
    <DisplayRoutes/>
    <PatientRoutes/>
    <AccountsRoutes/>
    </>
  )
}

export default ManagerRoutes